// idで指定した要素のwidth, heightを取得する
import { useState, useEffect } from 'react';
 
const useElementDimensions = (elementId: string, display?: boolean) => {
  const getElementDimensions = () => {
    const targetElement = document.getElementById(elementId);
    if (targetElement !== null) {
      const { clientWidth: width, clientHeight: height } = targetElement;
      return { width, height };
    } else {
      console.log('Target Element is not made yet')
      const width = undefined;
      const height = undefined;
      return { width, height };
    }
  }

  const [elementDimensions, setElementDimensions] = useState(getElementDimensions());

  useEffect(() => {
    const onResize = () => {
      setElementDimensions(getElementDimensions());
    }
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    const serchElement = () => {
      const target = document.getElementById(elementId);
      if (display && !target) setTimeout(serchElement, 1)
      else if (display && target) setElementDimensions(getElementDimensions());
    }
    serchElement();
  }, [display, document.getElementById(elementId)])

  return elementDimensions;
}

export default useElementDimensions;
